// extracted by mini-css-extract-plugin
export default {"card":"RestorePassword_card__o5vES","input":"RestorePassword_input__a1Pwa"};